/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

const SITE_PRIMARY = '#836F50'
const BROWN = '#AA9056'
const GOLDENROD = '#FFBE00'
const BLACK = '#000'
const WHITE = '#FFF'
const SOCIAL_BG = '#E0E0E0'

export const IconFlag = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24">
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.297 9.867V6.214l3.627 1.827-3.627 1.826zm-.57 8.619c-1.33 0-2.274-.177-2.767-.345.493-.167 1.437-.344 2.767-.344 1.33 0 2.274.177 2.768.344-.494.168-1.437.345-2.768.345zm5.726-10.959l-5.471-2.754a.568.568 0 0 0-.825.513V16.66c-1.305.049-3.647.3-3.647 1.48 0 1.385 3.228 1.492 4.217 1.492.99 0 4.218-.107 4.218-1.492 0-1.18-2.343-1.431-3.648-1.48V11.15l5.156-2.596a.574.574 0 0 0 0-1.027z"
          fill={props.fill || SITE_PRIMARY}
        />
      </g>
    </svg>
  </SvgIcon>
)

export const IconComplete = props => (
  <SvgIcon {...props}>
    <svg width="25" height="24">
      <g fill="none" fillRule="nonzero" transform="translate(.25)">
        <circle cx="12" cy="12" r="12" fill={props.fill || GOLDENROD} />
        <path
          d="M12.877 11.566l-.83-1.158-.828 1.158-.63-.465.829-1.157-1.341-.441.24-.751 1.342.441v-1.43h.778v1.43l1.341-.441.241.75-1.341.442.829 1.157-.63.465zm-3.943-.25c0 1.741 1.396 3.158 3.114 3.158 1.717 0 3.114-1.417 3.114-3.158V5.789H8.934v5.527zM6.54 7.742c-.097 1.818.435 2.925 1.615 3.368V7.368H6.928a.391.391 0 0 0-.388.374zm10.654-.374h-1.253v3.75c1.198-.438 1.738-1.545 1.642-3.376a.392.392 0 0 0-.389-.374zm-2.421 10.658c0-.435-.35-.79-.779-.79h-3.892a.785.785 0 0 0-.779.79v.79h5.45v-.79zm1.103-6.057a3.901 3.901 0 0 1-3.439 3.254v1.224h1.557c.86 0 1.557.708 1.557 1.58v1.578H8.544v-1.579c0-.871.698-1.579 1.558-1.579h1.557v-1.224a3.9 3.9 0 0 1-3.44-3.262c-1.265-.345-2.61-1.383-2.457-4.261a1.175 1.175 0 0 1 1.166-1.121h1.227V5h7.786v1.579h1.253c.62 0 1.133.493 1.166 1.121.154 2.9-1.211 3.93-2.484 4.269z"
          fill={props.stroke || BLACK}
        />
      </g>
    </svg>
  </SvgIcon>
)

export const IconArrow = props => (
  <SvgIcon {...props}>
    <svg width="32" height="7">
      <g fill="none" fillRule="evenodd" stroke={props.stroke || BLACK}>
        <path strokeLinecap="square" d="M.583 3.5h25.009" />
        <path d="M23.042 0l3.5 3.5-3.5 3.5" />
      </g>
    </svg>
  </SvgIcon>
)

export const IconArrowExternal = props => (
  <SvgIcon {...props}>
    <svg width="20" height="11">
      <path
        fillRule="nonzero"
        d="M.83 5.531h17.562l-2.196-2.196.587-.587 3.198 3.198-3.198 3.198-.587-.586 2.196-2.197H.83v3.722h8.273V7.832h.829v3.08H0V.98h9.932v3.168h-.829V1.81H.83z"
      />
    </svg>
  </SvgIcon>
)

export const IconButtonCtaArrow = props => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.4531 6.89929H0.71875C0.511111 6.89929 0.33941 6.81361 0.203646 6.64225C0.067882 6.47089 0 6.25416 0 5.99208C0 5.73 0.067882 5.51327 0.203646 5.34191C0.33941 5.17055 0.511111 5.08487 0.71875 5.08487H15.4771L13.4167 2.48419C13.2889 2.32291 13.225 2.1213 13.225 1.87938C13.225 1.63746 13.2969 1.42577 13.4406 1.24433C13.5844 1.06289 13.7521 0.972168 13.9438 0.972168C14.1354 0.972168 14.3031 1.06289 14.4469 1.24433L17.7052 5.35703C17.7851 5.45783 17.841 5.55863 17.8729 5.65944C17.9049 5.76024 17.9208 5.87112 17.9208 5.99208C17.9208 6.11304 17.9049 6.22392 17.8729 6.32473C17.841 6.42553 17.7851 6.52633 17.7052 6.62713L14.4469 10.7398C14.2872 10.9414 14.1155 11.0372 13.9318 11.0271C13.7481 11.017 13.5844 10.9213 13.4406 10.7398C13.2969 10.5584 13.225 10.3417 13.225 10.0897C13.225 9.83766 13.2889 9.63101 13.4167 9.46973L15.4531 6.89929Z"
      fill="currentColor"
    />
  </svg>
)

export const IconButtonBackArrow = props => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.46777 5.10022L17.2021 5.10022C17.4098 5.10022 17.5815 5.1859 17.7173 5.35726C17.853 5.52862 17.9209 5.74535 17.9209 6.00743C17.9209 6.26952 17.853 6.48624 17.7173 6.6576C17.5815 6.82896 17.4098 6.91465 17.2021 6.91465L2.44381 6.91464L4.50423 9.51532C4.63201 9.6766 4.6959 9.87821 4.6959 10.1201C4.6959 10.3621 4.62402 10.5737 4.48027 10.7552C4.33652 10.9366 4.16881 11.0273 3.97715 11.0273C3.78548 11.0273 3.61777 10.9366 3.47402 10.7552L0.215687 6.64248C0.135827 6.54168 0.079924 6.44088 0.0479798 6.34007C0.0160355 6.23927 6.14634e-05 6.12839 6.1474e-05 6.00743C6.14846e-05 5.88647 0.0160355 5.77559 0.0479798 5.67479C0.0799241 5.57398 0.135827 5.47318 0.215687 5.37238L3.47402 1.25968C3.63374 1.05808 3.80545 0.962318 3.98913 0.972398C4.17281 0.982478 4.33652 1.07824 4.48027 1.25968C4.62402 1.44112 4.6959 1.65785 4.6959 1.90985C4.6959 2.16185 4.63201 2.3685 4.50423 2.52978L2.46777 5.10022Z"
      fill="currentColor"
    />
  </svg>
)

export const IconDate = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24">
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.041 8.825c.295 0 .533-.26.533-.58v-.234h7.218v.235c0 .319.24.579.534.579.294 0 .534-.26.534-.58v-.234h.773v1.607H6.713V8.011h.795v.235c0 .319.238.579.533.579zm-.601 8.717h9.465v-6.766H7.44v6.766zM18.167 6.853h-1.33v-.63c0-.319-.238-.578-.533-.578-.294 0-.533.259-.533.579v.63H8.574v-.63c0-.32-.238-.58-.533-.58-.295 0-.533.26-.533.58v.63h-1.33c-.294 0-.533.258-.533.578v2.765c0 .32.24.58.533.58h.194v7.345c0 .32.24.579.535.579h10.532c.294 0 .534-.26.534-.58v-7.345h.194c.294 0 .534-.259.534-.579V7.432c0-.32-.24-.579-.534-.579z"
          fill={props.fill || SITE_PRIMARY}
        />
      </g>
    </svg>
  </SvgIcon>
)

export const IconLive = props => (
  <SvgIcon {...props}>
    <svg width="25" height="25">
      <g fill="none" fillRule="evenodd" transform="translate(.75 .75)">
        <circle
          cx="12"
          cy="12"
          r="12"
          fill={props.fill || GOLDENROD}
          fillRule="nonzero"
        />
        <path
          d="M17.316 6.863c2.648 2.867 2.648 7.548-.015 10.43a.545.545 0 0 1-.43.202.6.6 0 0 1-.429-.202.703.703 0 0 1 0-.945c2.176-2.356 2.176-6.184 0-8.54a.703.703 0 0 1 0-.945.581.581 0 0 1 .874 0zM15.07 9.176c1.582 1.6 1.596 4.203-.015 5.804a.58.58 0 0 1-.443.194.637.637 0 0 1-.444-.194.646.646 0 0 1 0-.913c1.094-1.091 1.08-2.886 0-3.978a.646.646 0 0 1 0-.913.628.628 0 0 1 .902 0zM7.718 7.81c-2.175 2.359-2.175 6.193-.015 8.536a.706.706 0 0 1 0 .947.545.545 0 0 1-.429.202.598.598 0 0 1-.43-.202c-2.646-2.871-2.646-7.559 0-10.43a.58.58 0 0 1 .874 0 .706.706 0 0 1 0 .947zm2.273 2.279a2.86 2.86 0 0 0-.015 3.978.646.646 0 0 1 0 .913.581.581 0 0 1-.444.194.639.639 0 0 1-.444-.194 4.137 4.137 0 0 1 0-5.804.63.63 0 0 1 .903 0 .646.646 0 0 1 0 .913zm2.089.444c.63 0 1.14.52 1.14 1.16 0 .641-.51 1.16-1.14 1.16-.63 0-1.14-.519-1.14-1.16 0-.64.51-1.16 1.14-1.16z"
          fill={props.stroke || BLACK}
        />
      </g>
    </svg>
  </SvgIcon>
)

export const IconMarker = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24">
      <g fill="none" fillRule="evenodd">
        <path
          d="M12.173 4.712c1.484 0 2.907.573 3.957 1.592a5.354 5.354 0 0 1 1.638 3.843 5.532 5.532 0 0 1-.886 2.944c-1.121 1.802-4.14 6.131-4.269 6.314a.528.528 0 0 1-.437.228.529.529 0 0 1-.437-.228c-.128-.183-3.147-4.518-4.268-6.314a5.54 5.54 0 0 1-.894-2.946c0-1.44.59-2.822 1.639-3.842a5.683 5.683 0 0 1 3.957-1.59zm3.805 7.853a4.558 4.558 0 0 0 .741-2.418c0-1.577-.867-3.035-2.273-3.823a4.664 4.664 0 0 0-4.546 0c-1.407.788-2.274 2.246-2.274 3.823.013.856.27 1.693.742 2.418.857 1.374 2.906 4.348 3.805 5.643.899-1.295 2.948-4.267 3.805-5.643zM12.173 7.51a2.798 2.798 0 1 1-.002 5.597 2.798 2.798 0 0 1 .002-5.597zm0 4.546a1.749 1.749 0 1 0 0-3.497 1.749 1.749 0 0 0 0 3.497z"
          fillRule="nonzero"
          fill={props.fill || SITE_PRIMARY}
        />
      </g>
    </svg>
  </SvgIcon>
)

export const IconMarkerWithArea = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24">
      <g fill="none" strokeWidth="0.25" stroke={props.stroke || SITE_PRIMARY}>
        <circle fill="#f5f5f5" stroke="none" cx="12" cy="12" r="12" />
        <circle cx="12.15" cy="9.5" r="1.5" />
        <path d="M13.8683+14.1357C15.2214+14.3879+16.156+14.9261+16.156+15.5493C16.156+16.4143+14.355+17.1156+12.1333+17.1156C9.91167+17.1156+8.11065+16.4143+8.11065+15.5493C8.11065+14.9536+8.96456+14.4356+10.2217+14.1707" />
        <path d="M9.60309+10.6544C9.48353+10.3416+9.4179+10.0011+9.4179+9.64498C9.4179+8.11431+10.6301+6.87346+12.1254+6.87346C13.6207+6.87346+14.8329+8.11431+14.8329+9.64498C14.8329+10.0168+14.7614+10.3715+14.6317+10.6955C14.2273+11.7053+12.176+15.0301+12.176+15.0301C12.176+15.0301+9.99734+11.6859+9.60309+10.6544Z" />
      </g>
    </svg>
  </SvgIcon>
)

export const IconNext = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24">
      <defs>
        <path
          d="M12.835 13.363a1.332 1.332 0 0 1-2.352-.86c0-.501.277-.939.687-1.167V7.614h1.091v3.631c.45.16.788.552.87 1.032l3.76 2.1-.552.943-3.504-1.957zm4.3-5.629a6.622 6.622 0 0 0-3.35-2.115 6.62 6.62 0 0 0-5.06.666 6.674 6.674 0 0 0-2.44 9.107 6.617 6.617 0 0 0 4.049 3.105 6.611 6.611 0 0 0 5.058-.665l.627-.366.448.767-.628.367a7.51 7.51 0 0 1-5.735.756 7.508 7.508 0 0 1-4.589-3.52 7.51 7.51 0 0 1-.755-5.733 7.509 7.509 0 0 1 3.521-4.587 7.505 7.505 0 0 1 5.734-.755 7.496 7.496 0 0 1 3.952 2.585l1.703-.794-1.216 3.34-3.34-1.216 2.021-.942z"
          id="a-next"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle
          cx="12"
          cy="12"
          r="12"
          fill={props.fill || GOLDENROD}
          fillRule="nonzero"
        />
        <use fill={props.stroke || BLACK} href="#a-next" />
      </g>
    </svg>
  </SvgIcon>
)

export const IconClubs = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 54 63">
      <path
        d="M26.98 62.22C12.08 62.22-.04 49.9-.04 34.75V4.52l1.19-.39c16.9-5.57 34.77-5.57 51.67 0l1.18.39v30.24c0 15.14-12.12 27.46-27.02 27.46zM3.41 7.03v27.73c0 13.24 10.57 24.02 23.57 24.02S50.55 48 50.55 34.76V7.03c-15.45-4.84-31.69-4.84-47.14 0z"
        fill={props.fill || BROWN}
      />
      <path
        d="M44.54 36.36l-.9-2.04c-.33-.74-.95-1.3-1.71-1.53-.77-.23-1.59-.12-2.26.31l-6.99 4.5-4.5-9.62 6.55-14.01-.96-.46-.97-.47-5.8 12.4-5.8-12.41-1.93.93 6.55 14.01-4.5 9.62-6.99-4.5a2.7 2.7 0 00-2.26-.32c-.76.23-1.39.79-1.71 1.53l-.9 2.05c-.61 1.38-.01 3.03 1.34 3.67l5.2 2.5c.67.32 1.37.47 2.06.47 1.83 0 3.59-1.05 4.43-2.84L27 30.51l4.51 9.64c.84 1.79 2.6 2.84 4.43 2.84.69 0 1.4-.15 2.06-.47l5.2-2.48c1.35-.65 1.95-2.3 1.34-3.68"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.fill || BROWN}
      />
    </svg>
  </SvgIcon>
)

export const IconTicket = props => (
  <svg width={28} height={28} {...props}>
    <title>Tickets</title>
    <g fill="none" fillRule="evenodd">
      <path
        d="M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0zm2.047 6a.359.359 0 00-.238.098l-9.711 9.711c-.13.13-.13.34-.002.47l1.533 1.549a.335.335 0 00.237.098.358.358 0 00.236-.098c.57-.57 1.5-.57 2.07 0 .57.572.57 1.5 0 2.07a.332.332 0 000 .472l1.549 1.534a.334.334 0 00.47-.002l9.711-9.71a.332.332 0 00-.003-.475l-1.663-1.619c-.017-.016-.033-.021-.047-.031-.022-.016-.042-.034-.066-.043-.017-.007-.034-.006-.052-.01-.024-.006-.049-.014-.074-.014-.02 0-.04.008-.06.012-.022.004-.044.005-.064.014-.022.008-.04.025-.06.039-.016.011-.034.018-.049.032-.248.25-.58.386-.93.386l-.15-.008a1.308 1.308 0 01-.782-.378 1.308 1.308 0 01-.386-.93c0-.352.138-.683.386-.932.01-.01.015-.023.023-.034.019-.024.038-.047.05-.074.007-.02.008-.04.012-.06.004-.022.012-.043.012-.065 0-.024-.007-.048-.013-.072-.003-.018-.003-.036-.01-.053-.01-.025-.028-.046-.044-.069-.01-.013-.015-.028-.026-.04l-.003-.003-.001-.002-1.618-1.662A.334.334 0 0016.047 6zm-.059 1l1.148 1.179a1.915 1.915 0 00.204 2.48c.365.364.849.565 1.365.565l.173-.007a1.92 1.92 0 00.943-.353L21 12.01l-2.965 2.966-.56-.56a.324.324 0 10-.459.459l.56.56L12.011 21l-1.063-1.053a2.076 2.076 0 00-.213-2.683c-.73-.73-1.872-.8-2.682-.212L7 15.988l5.564-5.564.56.56a.324.324 0 10.459-.46l-.56-.559L15.988 7zm-1.419 5.098a.333.333 0 10-.471.471l1.333 1.334a.332.332 0 00.471 0 .334.334 0 000-.472z"
        fill={props.fill || SITE_PRIMARY}
      />
    </g>
  </svg>
)

export const IconPlayVideo = props => (
  <SvgIcon {...props}>
    <svg width="24" height="24" viewBox="0 0 72 72">
      <title>video icon</title>
      <defs>
        <path
          d="M25.384 13.939L10.812 4.22c-1.296-.864-3.034.062-3.034 1.617v19.436c0 1.555 1.738 2.48 3.034 1.617l14.572-9.72a1.941 1.941 0 000-3.231"
          id="prefix__a"
        />
      </defs>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <circle
          stroke={props.stroke || WHITE}
          strokeWidth={2}
          opacity={0.8}
          cx={35}
          cy={35}
          r={35}
        />
        <use
          fill={props.fill || WHITE}
          xlinkHref="#prefix__a"
          transform="translate(21 19.444)"
        />
      </g>
    </svg>
  </SvgIcon>
)

// --------------------------
// Coaches Page Icons
// --------------------------
export const IconCheckMark = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <polygon
        points="18.72 7.93 17.66 6.87 9.53 15.01 6.34 11.82 5.28 12.88 8.46 16.07 8.46 16.07 9.53 17.13 10.59 16.07 10.59 16.07 18.72 7.93"
        fill={props.fill || SITE_PRIMARY}
      />
    </svg>
  </SvgIcon>
)

export const IconInfo = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        d="M12,6a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-1a7,7,0,1,0,7,7,7,7,0,0,0-7-7Zm.75,4.75h-1.5V8.25h1.5Zm0,1.5h-1.5v4.5h1.5Z"
        fill={props.fill || SITE_PRIMARY}
      />
    </svg>
  </SvgIcon>
)

export const IconInfoActive = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={props.fill || SITE_PRIMARY}
      />
    </svg>
  </SvgIcon>
)

export const IconTrashcan = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        d="M15,9.83v7a.38.38,0,0,1-.34.34H9.34A.38.38,0,0,1,9,16.83v-7h6m1-1H8v8a1.31,1.31,0,0,0,.41.94,1.27,1.27,0,0,0,.93.4h5.32a1.27,1.27,0,0,0,.93-.4,1.31,1.31,0,0,0,.41-.94v-8Zm.66-2.35V7.83H7.34V6.48H9.66l.68-.65h3.32l.68.65Z"
        fill={props.fill || BLACK}
      />
    </svg>
  </SvgIcon>
)

// Coach Contact
export const IconPhone = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        d="M6.66,6A.65.65,0,0,0,6,6.66a10.92,10.92,0,0,0,3.33,8,10.92,10.92,0,0,0,8,3.33.65.65,0,0,0,.66-.66V15a.63.63,0,0,0-.19-.47.65.65,0,0,0-.47-.19A7.44,7.44,0,0,1,15,14a.55.55,0,0,0-.24-.05.66.66,0,0,0-.45.2l-1.47,1.47a10.06,10.06,0,0,1-4.4-4.4L9.88,9.72A.66.66,0,0,0,10,9a7.44,7.44,0,0,1-.37-2.37.65.65,0,0,0-.19-.47A.63.63,0,0,0,9,6H6.66m0-1H9a1.67,1.67,0,0,1,1.18.48,1.64,1.64,0,0,1,.48,1.18A6.29,6.29,0,0,0,11,8.71v0h0a1.62,1.62,0,0,1-.41,1.68l-.93.94a8.91,8.91,0,0,0,3,3l.93-.93a1.6,1.6,0,0,1,1.16-.5,1.49,1.49,0,0,1,.58.11,6.48,6.48,0,0,0,2,.31,1.64,1.64,0,0,1,1.18.48A1.67,1.67,0,0,1,19,15v2.34A1.64,1.64,0,0,1,17.34,19a12,12,0,0,1-8.72-3.62A12,12,0,0,1,5,6.66,1.64,1.64,0,0,1,6.66,5Z"
        fill={props.fill || SITE_PRIMARY}
      />
    </svg>
  </SvgIcon>
)

export const IconEmail = props => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 24 24">
      <path
        d="M17.84,19.6h-12a2,2,0,0,1-2-2V7.6a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v10A2,2,0,0,1,17.84,19.6Zm-12-13a1,1,0,0,0-1,1v10a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1V7.6a1,1,0,0,0-1-1Z"
        fill={props.fill || SITE_PRIMARY}
      />
      <polygon
        points="11.84 14.24 6.53 9.99 7.15 9.21 11.84 12.96 16.52 9.21 17.15 9.99 11.84 14.24"
        fill={props.fill || SITE_PRIMARY}
      />
    </svg>
  </SvgIcon>
)

// Skills Icons by Skill Name
export const IconSkill = props => {
  switch (props.type) {
    case 'Full Swing':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M47.59,20.3l-3.09,4a.56.56,0,0,1-.5.3h0l-.13,0-.09,0a.57.57,0,0,1-.18-.12h0s-.06,0-.07-.05l-3.1-4a.61.61,0,0,1,.11-.85.6.6,0,0,1,.84.11l2,2.53A19.4,19.4,0,0,0,8.88,11.84a.6.6,0,0,1-.84.1.61.61,0,0,1-.1-.85A20.59,20.59,0,0,1,44.51,22.32l2.13-2.75a.59.59,0,0,1,.84-.11A.6.6,0,0,1,47.59,20.3ZM39.34,36.85a.6.6,0,0,0-.85,0,19.4,19.4,0,0,1-33.8-11l1.95,2.53a.6.6,0,0,0,.84.11.61.61,0,0,0,.11-.85l-3.1-4s0,0-.06-.05l0,0a.4.4,0,0,0-.15-.1A.51.51,0,0,0,4,23.4a.59.59,0,0,0-.51.31l-3.08,4a.6.6,0,0,0,.11.84.58.58,0,0,0,.37.13.6.6,0,0,0,.47-.23l2.12-2.76a20.6,20.6,0,0,0,35.91,12A.6.6,0,0,0,39.34,36.85Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Club Fitting':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M37.47,42.47,28.83,25.36V24a2.57,2.57,0,0,0-2.28-2.54V19.71a.6.6,0,0,0-.6-.6H23.39V16.24a2.78,2.78,0,0,0,1.59.5H27.2a2.79,2.79,0,0,0,0-5.58H25A2.79,2.79,0,0,0,22.19,14v5.16H20.83V5.32a2.72,2.72,0,0,0,1.59.51h2.22a2.79,2.79,0,0,0,0-5.58H22.42A2.79,2.79,0,0,0,19.63,3V19.11h-1.3V9.57a2.79,2.79,0,0,0-2.79-2.79H13.32a2.79,2.79,0,0,0,0,5.58h2.22a2.8,2.8,0,0,0,1.59-.5v7.25H14.5a.6.6,0,0,0-.6.6v1.72A2.57,2.57,0,0,0,11.62,24v4.85a1.64,1.64,0,0,0-1.48,1.63v11a1.65,1.65,0,0,0,1.5,1.64,2.56,2.56,0,0,0,2.26,2.33v1.72a.6.6,0,0,0,.6.6H26a.6.6,0,0,0,.6-.6V45.43a2.56,2.56,0,0,0,2.28-2.54V28L36.4,43a2.44,2.44,0,0,1-2.17,3.53H28.48a.6.6,0,0,0,0,1.2h5.75a3.63,3.63,0,0,0,3.24-5.27ZM25,12.36H27.2a1.59,1.59,0,0,1,0,3.18H25a1.59,1.59,0,0,1,0-3.18ZM22.42,1.45h2.22a1.59,1.59,0,0,1,0,3.18H22.42a1.59,1.59,0,1,1,0-3.18Zm-6.88,9.71H13.32a1.59,1.59,0,0,1,0-3.18h2.22a1.59,1.59,0,0,1,0,3.18Zm-.44,9.15H25.35V21.4H15.1ZM11.34,41.46v-11a.45.45,0,0,1,.45-.45h4.14a.45.45,0,0,1,.45.45v11a.45.45,0,0,1-.45.45H11.79A.45.45,0,0,1,11.34,41.46Zm14,5.09H15.1V45.46H25.35Zm2.28-3.66a1.37,1.37,0,0,1-1.37,1.37H14.19a1.36,1.36,0,0,1-1.34-1.15h3.08a1.65,1.65,0,0,0,1.65-1.65v-11a1.65,1.65,0,0,0-1.65-1.65H12.82V24a1.38,1.38,0,0,1,1.37-1.37H26.26A1.38,1.38,0,0,1,27.63,24Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Course Strategy':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M38.82,32.17a9.16,9.16,0,0,1-6.21-2.45,12.19,12.19,0,0,0-8.24-3,12.81,12.81,0,0,0-7,2,10.23,10.23,0,0,1-10.71.72c-3.4-1.91-5.34-4.7-5.34-7.67,0-5.54,6.81-10,15.18-10,5.07,0,16,2,23.12,4.59h0c4.35,1.62,7.16,5.29,7.16,9.35a5.16,5.16,0,0,1-1.08,3,8.18,8.18,0,0,1-5.92,3.4C39.43,32.15,39.12,32.17,38.82,32.17ZM24.37,25.56a13.39,13.39,0,0,1,9.05,3.27,8,8,0,0,0,6.19,2.1A7,7,0,0,0,44.67,28a4,4,0,0,0,.87-2.3c0-3.56-2.51-6.78-6.39-8.22h0c-7-2.59-17.73-4.52-22.7-4.52-7.71,0-14,4-14,8.85,0,2.52,1.73,4.93,4.74,6.62a9,9,0,0,0,9.45-.67A14,14,0,0,1,24.37,25.56ZM13.29,19.13c.26-.15.54-.29.84-.43a.6.6,0,1,0-.49-1.09,10.29,10.29,0,0,0-.94.47.61.61,0,0,0-.23.82.62.62,0,0,0,.82.23Zm10.14-.46a.52.52,0,0,1-.21,0,12.77,12.77,0,0,0-1.49-.47A.6.6,0,0,1,22,17a16,16,0,0,1,1.62.52.6.6,0,0,1-.22,1.16ZM17,17.91a.61.61,0,0,1-.59-.53.6.6,0,0,1,.52-.67,15.66,15.66,0,0,1,1.7-.11h0a.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6,15.52,15.52,0,0,0-1.55.1Zm19.36,7.56-.12,0A10.88,10.88,0,0,1,34.6,25,.6.6,0,0,1,35,23.86a12,12,0,0,0,1.48.42A.6.6,0,0,1,37,25,.61.61,0,0,1,36.38,25.47Zm-4.5-1.88a.64.64,0,0,1-.3-.08q-.7-.42-1.41-.87a.6.6,0,0,1,.65-1c.46.29.91.58,1.37.84a.61.61,0,0,1,.21.83A.59.59,0,0,1,31.88,23.59ZM27.76,21a.62.62,0,0,1-.32-.09c-.45-.29-.91-.57-1.37-.84a.6.6,0,0,1-.22-.82.61.61,0,0,1,.82-.22c.48.28.95.57,1.42.87a.59.59,0,0,1,.18.82A.61.61,0,0,1,27.76,21Zm12,4.52a10.46,10.46,0,0,0,1-.27.6.6,0,0,0,.4-.75.61.61,0,0,0-.76-.39,7.43,7.43,0,0,1-.9.23A.6.6,0,0,0,39,25a.61.61,0,0,0,.59.49ZM11.43,23.39a.59.59,0,0,0,0-.85L8.72,19.82a.6.6,0,1,0-.85.85l2.72,2.72a.6.6,0,0,0,.84,0Zm-2.71,0,2.71-2.72a.6.6,0,0,0-.84-.85L7.87,22.54a.61.61,0,0,0,0,.85.62.62,0,0,0,.85,0Zm23.5,21.74a6.8,6.8,0,0,1-2.77-.57,8.64,8.64,0,0,0-4.25-.77,12.67,12.67,0,0,1-3-.11,9,9,0,0,0-3.61.06,11.57,11.57,0,0,1-2.72.32c-4.29,0-7.64-2.19-7.64-5,0-2,1.81-3.81,4.63-4.58a9.82,9.82,0,0,0,4-2.34,10.87,10.87,0,0,1,7.33-2.61c3.66,0,6.93,1.53,8.53,4a9.27,9.27,0,0,0,3.07,2.76h0a4.66,4.66,0,0,1,2.36,3.92C38.11,42.94,35.47,45.13,32.22,45.13Zm-6.37-2.57a10,10,0,0,1,4.09.91,5.77,5.77,0,0,0,2.28.46c2.58,0,4.69-1.66,4.69-3.7a3.47,3.47,0,0,0-1.79-2.9,10.47,10.47,0,0,1-3.45-3.13c-1.36-2.1-4.31-3.46-7.52-3.46A9.67,9.67,0,0,0,17.63,33a11,11,0,0,1-4.46,2.61c-2.28.63-3.75,2-3.75,3.43,0,2.06,2.95,3.79,6.44,3.79a10.17,10.17,0,0,0,2.43-.29,10.29,10.29,0,0,1,4.09-.08,11.27,11.27,0,0,0,2.72.1Q25.48,42.56,25.85,42.56ZM34.42,7.21V4.91L36,6.51a.58.58,0,0,0,.84,0,.59.59,0,0,0,0-.85L34.24,3a.64.64,0,0,0-.19-.13.61.61,0,0,0-.46,0,.86.86,0,0,0-.2.13L30.77,5.66a.61.61,0,0,0,0,.85.59.59,0,0,0,.85,0l1.6-1.6v2.3L30.77,9.65a.61.61,0,0,0,0,.85.59.59,0,0,0,.85,0l1.6-1.6v2.55a.6.6,0,0,0,1.2,0V8.9L36,10.5a.58.58,0,0,0,.84,0,.59.59,0,0,0,0-.85Zm7.13,3V7.87l1.6,1.59a.58.58,0,0,0,.84,0,.59.59,0,0,0,0-.85L41.37,6a.64.64,0,0,0-.19-.13.62.62,0,0,0-.23,0h0a.59.59,0,0,0-.23,0,.86.86,0,0,0-.2.13L37.9,8.61a.61.61,0,0,0,0,.85.59.59,0,0,0,.85,0l1.6-1.59v2.29L37.9,12.6a.61.61,0,0,0,0,.85.59.59,0,0,0,.85,0l1.6-1.59V14.4a.6.6,0,1,0,1.2,0V11.86l1.6,1.59a.58.58,0,0,0,.84,0,.59.59,0,0,0,0-.85Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Physical Assessment':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M37.08,44.6H8.69a.6.6,0,0,1-.6-.6V6.76a.6.6,0,0,1,.6-.6h5.74a.6.6,0,1,1,0,1.2H9.28v36h27.8a.6.6,0,0,1,0,1.2Zm.6-21.13V6.76a.6.6,0,0,0-.6-.6H31.34a.6.6,0,0,0,0,1.2h5.14V23.47a.6.6,0,0,0,1.2,0Zm-7.56-6.73a.6.6,0,0,0-.6-.6H13.62a.6.6,0,0,0,0,1.2h15.9A.6.6,0,0,0,30.12,16.74Zm-7.95,6.73a.59.59,0,0,0-.6-.59h-8a.6.6,0,1,0,0,1.19h8A.6.6,0,0,0,22.17,23.47Zm0,6.74a.6.6,0,0,0-.6-.6h-8a.6.6,0,0,0,0,1.2h8A.6.6,0,0,0,22.17,30.21ZM29.27,9.4V4a.6.6,0,0,0-.6-.6H17.1a.6.6,0,0,0-.6.6V9.4a.6.6,0,0,0,.6.6H28.67A.6.6,0,0,0,29.27,9.4ZM17.7,4.6H28.07V8.8H17.7Zm12,34.32,10-10a.6.6,0,0,0-.85-.84l-9.58,9.57-3-3a.59.59,0,0,0-.85,0,.58.58,0,0,0,0,.84l3.42,3.42a.59.59,0,0,0,.85,0Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Putting':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M15.5,40.73a4.34,4.34,0,1,1,4.33-4.34A4.34,4.34,0,0,1,15.5,40.73Zm0-7.48a3.14,3.14,0,1,0,3.13,3.14A3.14,3.14,0,0,0,15.5,33.25Zm15.44,3.93V4.12a.6.6,0,0,0-1.2,0v.71H13.59a.6.6,0,0,0-.6.6V16.2a.6.6,0,0,0,.6.6H29.74V37.12C26.67,37,24.28,37,24,37a.6.6,0,0,0,0,1.2c2.07,0,4,0,5.74.13v1.82a.6.6,0,0,0,1.2,0V38.37c8.21.45,12.72,1.64,13,2.33-.36.93-7.33,2.58-19.94,2.58S4.42,41.63,4.06,40.76c0,0,.26-.61,3.3-1.26a.6.6,0,0,0-.26-1.18C4.17,39,2.86,39.7,2.86,40.73c0,3.71,20.28,3.75,21.14,3.75s21.14,0,21.14-3.75C45.14,38.4,37.11,37.52,30.94,37.18ZM14.19,15.6V13.53h3.39a.6.6,0,0,0,0-1.2H14.19V6H29.74V15.6Zm13.4-2.67a.6.6,0,0,0-.6-.6h-5.9a.6.6,0,0,0,0,1.2H27A.6.6,0,0,0,27.59,12.93Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Short Game':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M42.51.85a.61.61,0,0,0-.83.2L31.25,17.92l-.31-.19a1.14,1.14,0,0,0-1.52.34l-3.91,5.75a1,1,0,0,1-.44.35.92.92,0,0,1-.59,0L11.65,20.45A4.13,4.13,0,0,0,6.71,22.7L5.6,25.1A4.15,4.15,0,0,0,9.37,31H21.62a4.74,4.74,0,0,0,1.7-.31l2.1-.77a4.93,4.93,0,0,0,2.47-2l4.81-7.78a1.12,1.12,0,0,0,.14-.86,1.18,1.18,0,0,0-.52-.7l0,0L42.7,1.68A.61.61,0,0,0,42.51.85ZM26.87,27.27A3.7,3.7,0,0,1,25,28.8l-2.1.78a3.71,3.71,0,0,1-1.28.23H9.37a3,3,0,0,1-2.69-4.2L7.8,23.2a2.93,2.93,0,0,1,2.68-1.72,3.1,3.1,0,0,1,.84.12l12.83,3.74a2.13,2.13,0,0,0,2.35-.84l3.82-5.74,1.32.79Zm4.91,15H28.94a5.25,5.25,0,1,0-6.6,0H12.17a.6.6,0,0,0,0,1.2H31.78a.6.6,0,0,0,0-1.2ZM21.59,38.23a4.05,4.05,0,1,1,4.05,4.05A4.06,4.06,0,0,1,21.59,38.23Zm19.08,5.25h-4a.6.6,0,1,1,0-1.2h4a.6.6,0,1,1,0,1.2Zm-6.36,3.75H22A.6.6,0,1,1,22,46H34.31a.6.6,0,1,1,0,1.19ZM13.13,28.41H11.21a.6.6,0,1,1,0-1.2h1.92a.6.6,0,1,1,0,1.2Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Social Engagement':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M35.42,28.5a.45.45,0,0,1-.16,0,.6.6,0,0,1-.41-.74l3.84-13.21a.6.6,0,1,1,1.16.34L36,28.06A.62.62,0,0,1,35.42,28.5ZM20,27.13l-3-4.92a.59.59,0,0,0-.82-.21.61.61,0,0,0-.2.83l1.19,2L16,25.61a.61.61,0,0,0-.16.83.62.62,0,0,0,.5.27.58.58,0,0,0,.33-.1l1.16-.78,1.16,1.92a.59.59,0,0,0,.51.29.58.58,0,0,0,.31-.08A.61.61,0,0,0,20,27.13ZM47.23,24V34.87a4,4,0,0,1-.6,2.09l-2,3.19A3.91,3.91,0,0,1,41.31,42H40.4a4.48,4.48,0,0,1-1.09,1.78,4.57,4.57,0,0,1-6.47,0A4.48,4.48,0,0,1,31.75,42H15.25a4.55,4.55,0,0,1-8.65,0A6.28,6.28,0,0,1,.77,35.68V32.87a.61.61,0,0,1,.17-.43l2-2h0l5.81-5.81L14.09,7.89H11.53a1.38,1.38,0,0,1-1.14-2.16l1.53-2.22a1.38,1.38,0,0,1,1.13-.59H44.12A1.37,1.37,0,0,1,45.5,4.29V6.51a1.38,1.38,0,0,1-1.38,1.38H42.48V22.16h2.93A1.81,1.81,0,0,1,47.23,24ZM46,27.15H44.18v5.62H46ZM11.53,6.69H44.12a.18.18,0,0,0,.18-.18V4.29a.19.19,0,0,0-.18-.18H13.05a.16.16,0,0,0-.14.08L11.38,6.41a.15.15,0,0,0,0,.18A.16.16,0,0,0,11.53,6.69Zm3.82,1.2L10.07,24.38h2.07a3,3,0,0,1,2.59,1.47l4.15,6.88a3,3,0,0,1,.44,1.57v3.59H23l1.24-1.7a7.33,7.33,0,0,1,5.91-3H32V31.61L30.38,30H28a.6.6,0,0,1,0-1.2h6.22a.6.6,0,0,1,0,1.2H32.07l.91.91a.56.56,0,0,1,.18.42v1.83h2.68l2.83-9.72a1.84,1.84,0,0,1,1.75-1.31h.86V7.89Zm20.14,26.5H30.13a6.13,6.13,0,0,0-4.94,2.5l-.73,1h7.87a3.74,3.74,0,0,1,.51-.62h0A4.48,4.48,0,0,1,35,36.07ZM2,33.11v1.68H4.7l1.87-1.87V31.49h-3Zm4.41,7.58a1.11,1.11,0,0,1,0-.19,4.58,4.58,0,0,1,8.33-2.61h3.44V34.3a1.78,1.78,0,0,0-.27-.95l-4.14-6.88a1.84,1.84,0,0,0-1.57-.89H9.5L4.78,30.29H7.17a.6.6,0,0,1,.6.6v2.28a.64.64,0,0,1-.18.43L5.37,35.81A.6.6,0,0,1,5,36H2A5.06,5.06,0,0,0,6.37,40.69Zm7.94-.19a3.38,3.38,0,1,0-3.38,3.39A3.39,3.39,0,0,0,14.31,40.5Zm17.21.26a4.53,4.53,0,0,1,.22-1.67H15.26a4.4,4.4,0,0,1,.25,1.41,2.06,2.06,0,0,1,0,.26Zm6.94-2.65a3.4,3.4,0,0,0-4.78,0h0a3.38,3.38,0,1,0,4.78,0ZM46,34.87V34H43.58a.6.6,0,0,1-.6-.6V26.55a.6.6,0,0,1,.6-.6H46V24a.63.63,0,0,0-.63-.63h-5a.64.64,0,0,0-.6.45L36.29,36a4.53,4.53,0,0,1,4.34,4.81h.68a2.68,2.68,0,0,0,2.28-1.26l2-3.18A2.7,2.7,0,0,0,46,34.87Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Speed':
      return (
        <SvgIcon>
          <svg viewBox="0 0 48 48">
            <path
              d="M26.08,23a.59.59,0,0,1-.44-.2,30.77,30.77,0,0,1-2.23-2.71.6.6,0,1,1,1-.72c.66.89,1.38,1.77,2.15,2.62a.59.59,0,0,1,0,.85A.57.57,0,0,1,26.08,23ZM43,25.5a14.52,14.52,0,0,1-2.9,3.68l0,0-.07.05A14.51,14.51,0,0,1,30.31,33a16.34,16.34,0,0,1-1.71-.1l-8.75,8.75a.62.62,0,0,1-.85,0,.61.61,0,0,1,0-.85l8.16-8.16a14.5,14.5,0,0,1-3.8-1.44,15,15,0,0,1-1.43-.9L8.47,43.75a.59.59,0,0,1-.85,0,.59.59,0,0,1,0-.85L21,29.55a14.26,14.26,0,0,1-3.69-4.84l-5.47,5.47a.6.6,0,0,1-.84,0,.59.59,0,0,1,0-.85l5.81-5.81c-.12-.32-.24-.64-.33-1a14.28,14.28,0,0,1-.4-6.14l-4.66,4.66a.59.59,0,0,1-.85,0,.61.61,0,0,1,0-.85l6-6A14.57,14.57,0,0,1,20.5,8a.81.81,0,0,0,.09-.1l.08,0A14.44,14.44,0,0,1,43,25.5Zm.07-10.66A13.28,13.28,0,0,0,30.35,5.27a13.47,13.47,0,0,0-3.71.53,13.08,13.08,0,0,0-5.3,3c-1.05,1.07-.83,3.55.59,6.55a.59.59,0,0,1-.28.8.58.58,0,0,1-.26.06.61.61,0,0,1-.54-.34,12.43,12.43,0,0,1-1.37-5A13.21,13.21,0,0,0,17.6,22.22c0,.12.08.23.12.35l1.93-1.92a.58.58,0,0,1,.84,0,.59.59,0,0,1,0,.85l-2.31,2.31a13.18,13.18,0,0,0,3.65,4.88L25,25.56a.59.59,0,1,1,.84.84l-3,3A13.15,13.15,0,0,0,36.88,30c-2-.22-4.6-1.44-7.34-3.59a.6.6,0,1,1,.74-.94c3.77,2.95,7.41,4.11,8.91,2.86a13.2,13.2,0,0,0,3.87-13.53ZM30.34,41.64l5.89-5.89a.6.6,0,0,0-.85-.85l-5.89,5.89a.61.61,0,0,0,0,.85.62.62,0,0,0,.85,0ZM4.24,37.76l3.07-3.08a.59.59,0,0,0,0-.85.58.58,0,0,0-.84,0L3.39,36.91a.59.59,0,0,0,0,.85.61.61,0,0,0,.42.17A.65.65,0,0,0,4.24,37.76Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Tournament Strategy':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M34.21,9.82c-.9-2.39-4.08-4.16-8.09-4.64a2.68,2.68,0,0,0,.59-1.68,2.74,2.74,0,0,0-5.48,0,2.68,2.68,0,0,0,.58,1.66c-4.07.47-7.32,2.26-8.21,4.68a.59.59,0,0,0,.35.77.52.52,0,0,0,.21,0,.6.6,0,0,0,.56-.39c.86-2.33,4.72-4,9.19-4s8.31,1.68,9.18,4a.6.6,0,1,0,1.12-.42ZM24,2A1.54,1.54,0,1,1,22.43,3.5,1.54,1.54,0,0,1,24,2ZM19.1,33.14A11.51,11.51,0,0,1,13.73,27l-.36-1A18.93,18.93,0,0,1,13,13.93h4.14a.6.6,0,0,0,0-1.2H8.59a5.78,5.78,0,0,0-5.78,5.78,13.92,13.92,0,0,0,4.12,9.93A5.78,5.78,0,0,0,11,30.13a5.69,5.69,0,0,0,2.59-.63,12.78,12.78,0,0,0,4.92,4.7.77.77,0,0,0,.29.07.61.61,0,0,0,.53-.32A.61.61,0,0,0,19.1,33.14ZM7.77,27.59A12.77,12.77,0,0,1,4,18.51a4.59,4.59,0,0,1,4.58-4.58h3.22a20.09,20.09,0,0,0,.44,12.5l.35,1q.21.54.45,1.05A4.58,4.58,0,0,1,7.77,27.59ZM39.41,12.73H23.91a.6.6,0,0,0,0,1.2H34.78A19,19,0,0,1,34.45,26l-.36,1a11.55,11.55,0,0,1-5.37,6.16.61.61,0,0,0-.25.81.61.61,0,0,0,.53.32.68.68,0,0,0,.28-.07,12.74,12.74,0,0,0,5-4.77,5.83,5.83,0,0,0,2.74.71,5.76,5.76,0,0,0,4.08-1.7,13.92,13.92,0,0,0,4.12-9.93A5.78,5.78,0,0,0,39.41,12.73Zm.82,14.86a4.57,4.57,0,0,1-5.43.77c.15-.32.29-.64.41-1l.36-1A20.09,20.09,0,0,0,36,13.93h3.4A4.59,4.59,0,0,1,44,18.51,12.77,12.77,0,0,1,40.23,27.59ZM37.92,46H33.63a2.31,2.31,0,0,0-1.25-1.81L27.59,41.8a1.16,1.16,0,0,1-.64-1,1.14,1.14,0,0,1,.34-.81l1-1A2.34,2.34,0,0,0,29,37.27v-.09A.6.6,0,0,0,29,36H18.82a.6.6,0,0,0,0,1.2v.09a2.34,2.34,0,0,0,.69,1.66l1,1a1.18,1.18,0,0,1,.33.81,1.15,1.15,0,0,1-.63,1l-4.79,2.42A2.31,2.31,0,0,0,14.19,46H9.9a.61.61,0,0,0,0,1.21h28a.61.61,0,0,0,0-1.21ZM16,45.29l4.79-2.42a2.32,2.32,0,0,0,1.29-2.1,2.36,2.36,0,0,0-.68-1.66l-1-1a1.13,1.13,0,0,1-.34-.81v-.09h7.8v.09a1.13,1.13,0,0,1-.34.81l-1,1a2.36,2.36,0,0,0-.68,1.66,2.32,2.32,0,0,0,1.29,2.1l4.79,2.42a1.15,1.15,0,0,1,.59.74h-17A1.15,1.15,0,0,1,16,45.29Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Travel':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M24,38a.61.61,0,0,1-.53-.31l-10-18.15a12.05,12.05,0,1,1,21.14,0l-10,18.15A.59.59,0,0,1,24,38ZM24,2.91A10.85,10.85,0,0,0,14.48,19L24,36.15,33.52,19A10.84,10.84,0,0,0,24,2.91Zm-5.81,9.22a6,6,0,0,1,1.4-2.49.6.6,0,1,0-.87-.82,7.24,7.24,0,0,0-1.69,3,.61.61,0,0,0,.42.74l.16,0A.61.61,0,0,0,18.19,12.13Zm13,1.62A7.24,7.24,0,0,0,24,6.52a.6.6,0,1,0,0,1.2,6,6,0,1,1-5.81,7.66A.6.6,0,0,0,17,15.7a7.23,7.23,0,0,0,14.2-1.95ZM41.37,39.2c0-2.81-3.81-5.27-9.94-6.43a.6.6,0,0,0-.7.48.6.6,0,0,0,.48.7c5.36,1,9,3.12,9,5.25,0,2.85-6.5,5.89-16.17,5.89s-16.17-3-16.17-5.89c0-2.13,3.61-4.24,9-5.25a.6.6,0,0,0,.48-.7.61.61,0,0,0-.71-.48c-6.13,1.15-9.95,3.62-9.95,6.43,0,4,7.63,7.09,17.37,7.09S41.37,43.18,41.37,39.2Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Wedge Play':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M26.07,36.29H6.94a6.15,6.15,0,0,1-3.05-.8.6.6,0,0,1-.23-.82.6.6,0,0,1,.82-.22,5,5,0,0,0,2.46.64H26.07a5.94,5.94,0,0,0,2.13-.38l3.28-1.21a.61.61,0,0,1,.77.36.6.6,0,0,1-.36.77l-3.27,1.21A7.41,7.41,0,0,1,26.07,36.29ZM47.14,14.15l-4.09,6.62a1.64,1.64,0,0,1,.24.52,1.43,1.43,0,0,1-.17,1.09L35.6,34.54a7.4,7.4,0,0,1-3.71,3l-3.27,1.21a7.19,7.19,0,0,1-2.55.46H6.94a6.17,6.17,0,0,1-5.6-8.77l1.74-3.75a6.12,6.12,0,0,1,7.33-3.33l20.05,5.85a1.75,1.75,0,0,0,1.13,0,1.8,1.8,0,0,0,.85-.67l6.12-9A1.42,1.42,0,0,1,40,18.94l6.11-9.88a.6.6,0,0,1,.83-.2.61.61,0,0,1,.2.83l-6.06,9.78,1,.6,4-6.55a.6.6,0,0,1,.83-.19A.59.59,0,0,1,47.14,14.15Zm-5,7.42a.19.19,0,0,0-.1-.14l-2.16-1.29a.22.22,0,0,0-.31.07l-6.12,9A2.94,2.94,0,0,1,32,30.31a3,3,0,0,1-1.89.07l-20-5.85a4.92,4.92,0,0,0-5.9,2.68L2.42,31A5,5,0,0,0,6.94,38H26.07a6.17,6.17,0,0,0,2.13-.38l3.28-1.21a6.11,6.11,0,0,0,3.09-2.53L42.1,21.75A.24.24,0,0,0,42.12,21.57Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    case 'Wind Play':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 48 48">
            <path
              d="M37.87,22.07H9.13a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6H37.87a.59.59,0,0,1,.6.6A.6.6,0,0,1,37.87,22.07Zm-5.52,4.46a.6.6,0,0,0-.6-.6H11a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6H31.75A.6.6,0,0,0,32.35,26.53Zm5.52-23a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6,5.53,5.53,0,1,1,0,11.06H4A.6.6,0,0,0,4,17H37.87a6.73,6.73,0,1,0,0-13.46Zm0,27.46H4a.6.6,0,0,0,0,1.2H37.87a5.53,5.53,0,1,1,0,11.06.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6,6.73,6.73,0,1,0,0-13.46Z"
              fill={props.fill || SITE_PRIMARY}
            />
          </svg>
        </SvgIcon>
      )
    default:
      return null
  }
}

// Social Icons by Social Type
export const IconSocial = props => {
  switch (props.type) {
    case 'FB':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="12" fill={props.fill || SOCIAL_BG} />
            <path d="M15.23,10H12.82c0-.36,0-.67,0-1,0-.47.22-.63.69-.63h1.71V6H13.58a2.83,2.83,0,0,0-2.95,2.38,13.28,13.28,0,0,0-.14,1.67H8.77V12.5h1.77V18h2.24l0-4.87V12.5h2.41Z" />
          </svg>
        </SvgIcon>
      )
    case 'IG':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="12" fill={props.fill || SOCIAL_BG} />
            <path d="M13.32,19H9.64L9,19l-.72-.09a4.25,4.25,0,0,1-.78-.2,2.94,2.94,0,0,1-.66-.34,3.55,3.55,0,0,1-1.06-1,4,4,0,0,1-.59-1.46,4.67,4.67,0,0,1-.09-.74c0-.23,0-.46,0-.68s0-.43,0-.64,0-.62,0-.93V10.94c0-.12,0-.23,0-.34s0-.37,0-.55,0-.51,0-.76,0-.52.06-.77a4.54,4.54,0,0,1,.24-1,3,3,0,0,1,.44-.85,3.92,3.92,0,0,1,.51-.57,3.2,3.2,0,0,1,.55-.42,4.48,4.48,0,0,1,.58-.29A4.25,4.25,0,0,1,8.47,5.1c.25,0,.49,0,.74-.06s.56,0,.84,0h4.14l.78,0c.23,0,.45,0,.67.06a3.29,3.29,0,0,1,.61.12,4.41,4.41,0,0,1,.86.38,3.22,3.22,0,0,1,1.08,1,3.55,3.55,0,0,1,.5.94,4.49,4.49,0,0,1,.25,1.07c0,.25,0,.49,0,.73l0,.79v3.17c0,.17,0,.35,0,.52s0,.37,0,.55,0,.41,0,.61,0,.49-.07.74a3.36,3.36,0,0,1-.18.76,5.45,5.45,0,0,1-.25.55,2.12,2.12,0,0,1-.39.55c-.14.16-.3.31-.45.46a2,2,0,0,1-.43.33l-.26.13a4.7,4.7,0,0,1-1.76.47l-.54,0-.82,0h-.49ZM12,6.24H9.63c-.26,0-.52,0-.79,0a4.66,4.66,0,0,0-.73.13,2.26,2.26,0,0,0-.82.41,4.26,4.26,0,0,0-.43.42,2.33,2.33,0,0,0-.31.5,2.53,2.53,0,0,0-.12.36,2.42,2.42,0,0,0-.1.45c0,.1,0,.19,0,.28l0,.7c0,.24,0,.5,0,.74s0,.36,0,.54,0,.6,0,.9c0,.76,0,1.52,0,2.28,0,.15,0,.31,0,.46a5.93,5.93,0,0,0,.06.84,4.54,4.54,0,0,0,.19.81,2.2,2.2,0,0,0,.57.87,2.69,2.69,0,0,0,.84.52,4,4,0,0,0,.76.17c.33,0,.66.06,1,.07h4.39l.85,0a4.22,4.22,0,0,0,.61-.07,3.12,3.12,0,0,0,1-.34,2.07,2.07,0,0,0,.67-.58,2.7,2.7,0,0,0,.47-1.05,4.11,4.11,0,0,0,.08-.6c0-.23,0-.45,0-.67s0-.44,0-.66,0-.43,0-.65c0-.81,0-1.63,0-2.45,0-.31,0-.63,0-.94s0-.46,0-.69,0-.45-.09-.68a2.79,2.79,0,0,0-.18-.58A2.06,2.06,0,0,0,16.9,7,2.35,2.35,0,0,0,16,6.46a4.15,4.15,0,0,0-1.1-.18l-.54,0H12Z" />
            <path d="M12,15.12A3.1,3.1,0,1,1,15.11,12h0A3.11,3.11,0,0,1,12,15.12ZM10,12a2,2,0,1,0,2-2h0a2,2,0,0,0-2,2Z" />
            <path d="M16.65,8.35a1,1,0,1,1-2,0,1,1,0,0,1,2,0Z" />
          </svg>
        </SvgIcon>
      )
    case 'TWT':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="12" fill={props.fill || SOCIAL_BG} />
            <path d="M4.64,16.64a6.11,6.11,0,0,0,4.44-1.25,3.08,3.08,0,0,1-2.82-2.1,3.41,3.41,0,0,0,1.35-.06,3.08,3.08,0,0,1-1.74-1.08,3,3,0,0,1-.66-1.93,3.07,3.07,0,0,0,1.35.37,3,3,0,0,1-.92-4,8.65,8.65,0,0,0,6.23,3.16c0-.2,0-.38,0-.56A3,3,0,0,1,14.7,6a3.44,3.44,0,0,1,.64,0,3,3,0,0,1,1.6.82.22.22,0,0,0,.24.06,5.88,5.88,0,0,0,1.62-.61L19,6.23A3,3,0,0,1,17.7,7.85l0,0c.27-.06.55-.1.82-.18s.52-.17.82-.27a3.87,3.87,0,0,1-.35.45c-.34.35-.69.68-1.05,1a.29.29,0,0,0-.1.22,8.72,8.72,0,0,1-2.76,6.62,7.84,7.84,0,0,1-4.2,2.11,8.8,8.8,0,0,1-4.63-.39,8.08,8.08,0,0,1-1.56-.77S4.68,16.68,4.64,16.64Z" />
          </svg>
        </SvgIcon>
      )
    case 'YT':
      return (
        <SvgIcon {...props}>
          <svg viewBox="0 0 24 24">
            <circle
              cx="12.14"
              cy="12.02"
              r="12"
              fill={props.fill || SOCIAL_BG}
            />
            <path d="M12.14,17l-1.89,0L8.83,17l-1.27-.08a6.53,6.53,0,0,1-.76-.08,3.12,3.12,0,0,1-.59-.19,1.6,1.6,0,0,1-.75-.75A3.15,3.15,0,0,1,5.21,15a10.86,10.86,0,0,1-.13-1.13c0-.59-.06-1.18-.08-1.77,0-.29,0-.59,0-.88s0-.58.05-.86a10.48,10.48,0,0,1,.17-1.48,4.28,4.28,0,0,1,.15-.51,1.57,1.57,0,0,1,1.09-1,3.61,3.61,0,0,1,.87-.16l.84-.06.85,0,1.89,0q1.17,0,2.34,0l1.57,0c.49,0,1,0,1.48.07.31,0,.62,0,.94.08a3.11,3.11,0,0,1,.67.16,1.57,1.57,0,0,1,.94.91,3.7,3.7,0,0,1,.23.85q.09.63.12,1.26c0,.51.05,1,.06,1.52,0,.34,0,.68,0,1s0,.53,0,.79A10.08,10.08,0,0,1,19,15.18a2.85,2.85,0,0,1-.14.5,1.58,1.58,0,0,1-1.08,1,3.71,3.71,0,0,1-.82.15l-1.11.08L14.68,17l-2.1,0h-.44Zm-1.41-2.88c.09,0,3.65-2.08,3.69-2.13-.14-.1-3.63-2.11-3.69-2.12Z" />
          </svg>
        </SvgIcon>
      )
    default:
      return null
  }
}

export const IconFlagFilled = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7713 3.07295L7.45612 0.532709C7.32875 0.482912 7.17601 0.482912 7.04863 0.582507C6.92127 0.657281 6.87035 0.781691 6.87035 0.931236V11.4159C4.62978 11.5154 3 12.3621 3 13.4579C3 14.6283 4.83345 15.5 7.27772 15.5C9.72229 15.5 11.5554 14.6283 11.5554 13.4579C11.5554 12.3621 9.92583 11.5154 7.68493 11.4158L7.68509 5.56316L13.6945 3.8448C13.8728 3.79501 14 3.64562 14 3.47125C14.0002 3.29689 13.9237 3.12268 13.771 3.07288L13.7713 3.07295ZM10.7156 13.4577C10.7156 13.9558 9.39148 14.6531 7.27794 14.6531C5.18994 14.6531 3.84029 13.9308 3.84029 13.4577C3.84029 13.0094 4.9861 12.3619 6.84508 12.2623V13.881H7.7108V12.2623C9.56978 12.3619 10.7156 13.0094 10.7156 13.4577V13.4577Z"
      fill="#836F50"
    />
  </svg>
)

export const IconPrice = () => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 7c0-.367.3-.667.667-.667.367 0 .667.3.667.667 0 .367-.3.667-.667.667A.669.669 0 0 1 10 7Zm-4.667-.667h3.334V5H5.334v1.333Zm9.334-1V9.98l-1.88.627-1.12 3.726H8V13H6.667v1.333H3s-1.667-5.64-1.667-7.667A3.665 3.665 0 0 1 5 3h3.334A3.33 3.33 0 0 1 11 1.667a.999.999 0 0 1 .92 1.386 3.22 3.22 0 0 0-.213.767l1.513 1.513h1.447Zm-1.333 1.333h-.667l-2.333-2.333c0-.433.06-.86.173-1.273a2.01 2.01 0 0 0-1.393 1.273H5a2.336 2.336 0 0 0-2.333 2.333c0 1.254.813 4.434 1.34 6.334h1.327v-1.334h4V13h1.34l1.033-3.434 1.627-.546V6.667Z"
      fill="#836F50"
    />
  </svg>
)

export const IconCalendar = () => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M12.667 2H12V.667h-1.333V2H5.333V.667H4V2h-.667C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.593 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V3.333C14 2.6 13.4 2 12.667 2Zm0 10.667H3.333V6h9.334v6.667Zm0-8H3.333V3.333h9.334v1.334Zm-8 2.666H8v3.334H4.667V7.333Z"
        fill="#836F50"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const IconButtonCtaArrowExternal = props => (
  <svg width={20} height={11} {...props}>
    <path d="M.83 5.531h17.562l-2.196-2.196.587-.587 3.198 3.198-3.198 3.198-.587-.586 2.196-2.197H.83v3.722h8.273V7.832h.829v3.08H0V.98h9.932v3.168h-.829V1.81H.83z" />
  </svg>
)

export const IconMenuClose = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M3 18h13v-2H3v2Zm0-5h10v-2H3v2Zm0-7v2h13V6H3Zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59Z"
        fill="#000"
        fillOpacity=".87"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const IconMenuOpen = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M21 6H8v2h13V6Zm0 5H11v2h10v-2Zm0 7v-2H8v2h13ZM3 8.41 6.58 12 3 15.59 4.41 17l5-5-5-5L3 8.41Z"
        fill="#000"
        fillOpacity=".87"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M24 24H0V0h24z" />
      </clipPath>
    </defs>
  </svg>
)

export const IconDownload = props => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...props}>
    <path
      d="M5.78849 8.86258C5.69811 8.86258 5.61398 8.84816 5.5361 8.81931C5.45821 8.79047 5.38418 8.74095 5.31399 8.67075L2.98179 6.33857C2.87025 6.22703 2.81521 6.09651 2.81666 5.94699C2.81809 5.79748 2.87314 5.66455 2.98179 5.5482C3.09814 5.43186 3.23179 5.37177 3.38274 5.36792C3.5337 5.36407 3.66736 5.42032 3.78371 5.53667L5.22601 6.97897V1.24146C5.22601 1.08184 5.27986 0.948193 5.38754 0.840506C5.49523 0.732806 5.62888 0.678955 5.78849 0.678955C5.94811 0.678955 6.08176 0.732806 6.18944 0.840506C6.29713 0.948193 6.35098 1.08184 6.35098 1.24146V6.97897L7.79328 5.53667C7.90482 5.42513 8.03727 5.37008 8.19063 5.37152C8.344 5.37297 8.47885 5.43186 8.5952 5.5482C8.70385 5.66455 8.76009 5.79628 8.76393 5.94339C8.76778 6.09051 8.71154 6.22223 8.5952 6.33857L6.263 8.67075C6.19281 8.74095 6.11878 8.79047 6.04089 8.81931C5.96301 8.84816 5.87888 8.86258 5.78849 8.86258ZM1.51929 11.9289C1.14044 11.9289 0.819763 11.7977 0.557263 11.5352C0.294763 11.2727 0.163513 10.952 0.163513 10.5731V9.102C0.163513 8.94239 0.217363 8.80874 0.325063 8.70105C0.432751 8.59336 0.566401 8.53952 0.726013 8.53952C0.885626 8.53952 1.01928 8.59336 1.12696 8.70105C1.23465 8.80874 1.28849 8.94239 1.28849 9.102V10.5731C1.28849 10.6308 1.31253 10.6837 1.36061 10.7318C1.40869 10.7799 1.46159 10.8039 1.51929 10.8039H10.0577C10.1154 10.8039 10.1683 10.7799 10.2164 10.7318C10.2645 10.6837 10.2885 10.6308 10.2885 10.5731V9.102C10.2885 8.94239 10.3423 8.80874 10.45 8.70105C10.5577 8.59336 10.6914 8.53952 10.851 8.53952C11.0106 8.53952 11.1442 8.59336 11.2519 8.70105C11.3596 8.80874 11.4135 8.94239 11.4135 9.102V10.5731C11.4135 10.952 11.2822 11.2727 11.0197 11.5352C10.7572 11.7977 10.4365 11.9289 10.0577 11.9289H1.51929Z"
      fill="#1C1B1F"
    />
  </svg>
)

export const IconShare = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M9.99998 0.833252L6.66665 4.16658H9.16665V11.6666H10.8333V4.16658H13.3333L9.99998 0.833252ZM15 19.1666H4.99998C4.07498 19.1666 3.33331 18.4166 3.33331 17.4999V7.49992C3.33331 7.05789 3.50891 6.63397 3.82147 6.32141C4.13403 6.00885 4.55795 5.83325 4.99998 5.83325H7.49998V7.49992H4.99998V17.4999H15V7.49992H12.5V5.83325H15C15.442 5.83325 15.8659 6.00885 16.1785 6.32141C16.4911 6.63397 16.6666 7.05789 16.6666 7.49992V17.4999C16.6666 17.9419 16.4911 18.3659 16.1785 18.6784C15.8659 18.991 15.442 19.1666 15 19.1666Z"
      fill="#043362"
    />
  </svg>
)
